import { render, staticRenderFns } from "./SiteParticulars.vue?vue&type=template&id=e2b54358&scoped=true"
import script from "./SiteParticulars.vue?vue&type=script&lang=js"
export * from "./SiteParticulars.vue?vue&type=script&lang=js"
import style0 from "./SiteParticulars.vue?vue&type=style&index=0&id=e2b54358&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b54358",
  null
  
)

export default component.exports